export const PHONE_LINK = `tel:02162995050`